import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';

interface GeneratedCodeDialogProps {
  open: boolean;
  code: string | null;
  onClose: () => void;
}

const GeneratedCodeDialog: React.FC<GeneratedCodeDialogProps> = ({
  open,
  code,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>
        קוד Nuki נוצר בהצלחה
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary' }}>
            הקוד שנוצר עבור ההזמנה:
          </Typography>
          <Box
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              p: 3,
              borderRadius: 2,
              mb: 2,
            }}
          >
            <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', letterSpacing: 2 }}>
              {code}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            אנא שמור את הקוד הזה. הוא נשלח גם למשתמש באימייל.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
        >
          סגור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GeneratedCodeDialog;

